/* eslint-disable react/destructuring-assignment */
import React, { useState } from 'react';

import type { FC } from 'react';
import { useConfig } from '@packages/utilities';

import { InstallmentCalculatorDialog } from '@packages/installment-calculator';
import { Layout1 } from '../Layout1';
import { Layout2 } from '../Layout2';
import { Layout3 } from '../Layout3';

export type InstallmentCalulatorInDialogProps = {
  /**
   * the single installment value from the calculation result as integer (e.g. 1337)
   */
  singleInstallment: number;
  /**
   * the currency string from the calculation result
   */
  currency: string;
  /**
   * the number of installments from the calculation result
   */
  numberOfInstallments: number;
  /**
   * Product price value as int (e.g. 1337)
   */
  basePrice: number;
};

/**
 * Promotion component Layout 1
 *
 * component to promote the installment calculator in layout version 1
 *
 * */
export const InstallmentCalulatorInDialog: FC<InstallmentCalulatorInDialogProps> = ({
  singleInstallment,
  currency,
  numberOfInstallments,
  basePrice,
}) => {
  const [dialogOpened, setDialogOpened] = useState(false);
  const {
    installmentCalculator: { InstallmentCalculatorCallToActionLayout },
  } = useConfig();

  return (
    <>
      {dialogOpened && (
        <InstallmentCalculatorDialog
          basePrice={basePrice}
          open={dialogOpened}
          handleClose={() => setDialogOpened(false)}
        />
      )}
      {InstallmentCalculatorCallToActionLayout.layout === 'Layout1' && (
        <Layout1
          singleInstallment={singleInstallment}
          currency={currency}
          numberOfInstallments={numberOfInstallments}
          openInstallmentCalulatorHandler={() => setDialogOpened(true)}
        />
      )}
      {InstallmentCalculatorCallToActionLayout.layout === 'Layout2' && (
        <Layout2
          singleInstallment={singleInstallment}
          currency={currency}
          numberOfInstallments={numberOfInstallments}
          openInstallmentCalulatorHandler={() => setDialogOpened(true)}
        />
      )}
      {InstallmentCalculatorCallToActionLayout.layout === 'Layout3' && (
        <Layout3
          singleInstallment={singleInstallment}
          currency={currency}
          openInstallmentCalulatorHandler={() => setDialogOpened(true)}
        />
      )}
    </>
  );
};
